import { toast } from 'react-toastify';

import { CloseModal } from '@Actions/index';
import { store } from '@ReactStore/store';

import { ILinkedAccountModel } from '@Shared/models';

import { Api as apiService } from '../api';

export abstract class ManualUploadCardProgramApi {
  static create(programName: string, continueToUpload?: boolean) {
    if (!programName) {
      throw Error('Expected a program name');
    }
    return apiService
      .post('/api/web/accounts/cardprograms/manual_upload', {
        programName
      })
      .then((response: Response) => response.json() as Promise<ILinkedAccountModel>)
      .then((program) => {
        if (!continueToUpload) {
          store.dispatch(new CloseModal());
          window.location.reload();
        }
        return program;
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }
}
